import React, { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import Swal from "sweetalert2";
import { useLocation, useNavigate } from "react-router-dom";
import { useAPIQuery } from "../../../hooks/useAPIQuery";
import Select from "react-select";
import secureLocalStorage from "react-secure-storage";
import { VARIABLES } from "../../Constant";

const EditSupplier = () => {
    const userID = secureLocalStorage.getItem("userID");
    const delay_time = VARIABLES.delayTime;
    const navigate = useNavigate();
    const location = useLocation();
    console.log(location);
    // react Hook form Props
    const {
        register,
        handleSubmit,
        formState: { errors },
        control,
        reset,
    } = useForm();

    // select dropdown
    const [item, setItem] = useState([]);

    const { useFetch } = useAPIQuery({
        key: "api/generic",
        endpoint: "/api/generic/",
    });

    const { data, isLoading } = useFetch({
        abortOnNewRequest: true,
        refetchOnWindowFocus: false,
        staleTime: 1000 * 60 * 3,
        retry: 3,
        keepPlaceholder: true,
        refetchOnReconnect: true,
    });

    const { useUpdate } = useAPIQuery({
        key: "supplier",
        endpoint: "/api/supplier/",
    });

    const handleUpdateSupplier = (data) => {
        Swal.fire({
            title: "Supplier Updated!",
            text: data.message,
            icon: "success",
        }).then((result) => {
            if (result.isConfirmed) {
                setTimeout(() => {
                    navigate(-1);
                }, 2000);
            }
        });
    };

    const handleErrorSupplier = (data) => {
        Swal.fire({
            title: "Error Updating Supplier",
            text: data?.data?.data?.message,
            icon: "error",
        });
    };

    const { mutate, isPending } = useUpdate({
        onSuccess: handleUpdateSupplier,
        // onError: handleErrorSupplier,
        errorMessageFromServer: true,
        retry: 2,
    });

    // onSubmit handler to post form details
    const onSubmit = (data) => {
        let supplier = new FormData();
        supplier.append("first_name", data.first_name);
        supplier.append("last_name", data.last_name);
        supplier.append("email", data.email);
        supplier.append(
            "item_list",
            data?.item_id?.map((api) => api.value)?.join(",")
        );
        supplier.append("gst_number", data.gst_no);
        supplier.append("gst_certificate", data.gst_cert);
        // supplier.append("additional_docs", data.additional_docs);
        supplier.append("mobile_no", data.phone_number);
        supplier.append("address", data.address);
        supplier.append("updated_by", userID);

        for (var pair of supplier.entries()) {
            console.log(pair);
        }

        mutate({
            id: location.state.editpost.id,
            data: supplier,
        });
    };

    // Pre Population of Particular Product details
    useEffect(() => {
        const editSupplier = location.state.editpost;
        console.log(editSupplier);
        // defaultValues is a react form hook.
        if (editSupplier) {
            var defaultValues = {};
            defaultValues.client_location = editSupplier.client_location;
            defaultValues.company_name = editSupplier.company_name;
            defaultValues.gst_no = editSupplier.gst_number;
            defaultValues.address = editSupplier.address;
            defaultValues.first_name = editSupplier.user?.first_name;
            defaultValues.last_name = editSupplier.user?.last_name;
            defaultValues.email = editSupplier.user?.email;
            defaultValues.phone_number = editSupplier.user?.mobile_no;

            console.log(item);
            const filteredItems = item?.filter((obj) =>
                editSupplier?.items.includes(obj.id)
            );
            console.log(filteredItems);

            const getItemDetails = filteredItems.map((api) => {
                return {
                    value: api.id,
                    label: api.item_name,
                };
            });
            defaultValues.item_id = getItemDetails;

            reset(defaultValues);
        }
    }, [item]);

    useEffect(() => {
        if (data) {
            setItem(data.item.filter((api) => api.category === "Raw Material"));
        }
    }, [data]);

    return (
        <>
            <div className="nk-block-head nk-block-head-sm">
                <div className="nk-block-between">
                    <div className="nk-block-head-content">
                        <h4 className="nk-block-title"> Edit Supplier </h4>
                    </div>
                </div>
            </div>
            <div className="col-lg-12 col-md-12 col-sm-12">
                <div class="card">
                    <div class="card-inner">
                        {/* For Form : Use React hook forms */}
                        <form
                            onSubmit={handleSubmit(onSubmit)}
                            autoComplete="off"
                        >
                            <div className="row g-4">
                                <div className="col-lg-6 col-md-6 col-sm-12">
                                    <label className="form-label">
                                        Email Address
                                        <span className="fs-8 text-danger">
                                            {" "}
                                            *
                                        </span>
                                    </label>
                                    <input
                                        type="email"
                                        className="form-control"
                                        placeholder="Enter email address"
                                        id="email-forms-email"
                                        {...register("email", {
                                            required: true,
                                        })}
                                    />
                                    {errors.email && (
                                        <span className="fs-8 text-danger">
                                            Email Address is required
                                        </span>
                                    )}
                                </div>

                                <div className="col-lg-6 col-md-6 col-sm-12">
                                    <label className="form-label">
                                        Item
                                        <span className="fs-8 text-danger">
                                            {" "}
                                            *
                                        </span>
                                    </label>
                                    <Controller
                                        render={({ field }) => (
                                            <Select
                                                {...field}
                                                options={item?.map((api) => {
                                                    return {
                                                        value: api.id,
                                                        label: api.item_name,
                                                    };
                                                })}
                                                isMulti
                                                isLoading={isLoading}
                                                isClearable={true}
                                                id="select-forms-item_id"
                                            />
                                        )}
                                        rules={{ required: true }}
                                        name="item_id"
                                        control={control}
                                    />
                                    {errors.item_id && (
                                        <span className="fs-8 text-danger">
                                            Item is required
                                        </span>
                                    )}
                                </div>

                                <div className="col-lg-6 col-md-6 col-sm-12">
                                    <label className="form-label">
                                        First Name
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Enter first name"
                                        id="text-forms-first_name"
                                        {...register("first_name", {
                                            required: false,
                                        })}
                                    />
                                </div>

                                <div className="col-lg-6 col-md-6 col-sm-12">
                                    <label className="form-label">
                                        Last Name
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Enter last name"
                                        id="text-forms-last_name"
                                        {...register("last_name", {
                                            required: false,
                                        })}
                                    />
                                </div>

                                <div className="col-lg-6 col-md-6 col-sm-12">
                                    <div className="form-group">
                                        <label
                                            className="form-label"
                                            htmlFor="input-tel-optional_phone_field"
                                        >
                                            Phone Number
                                        </label>
                                        <div className="form-control-wrap">
                                            <input
                                                type="tel"
                                                className="form-control"
                                                placeholder="Enter phone number"
                                                {...register("phone_number", {
                                                    validate: (value) => {
                                                        if (!value) return true;
                                                        const phoneRegex =
                                                            /^\+?[1-9]\d{6,14}$/;
                                                        return (
                                                            phoneRegex.test(
                                                                value
                                                            ) ||
                                                            "Invalid phone number format"
                                                        );
                                                    },
                                                })}
                                            />
                                            {errors?.phone_number && (
                                                <small className="text-danger mt-1">
                                                    {
                                                        errors?.phone_number
                                                            ?.message
                                                    }
                                                </small>
                                            )}
                                        </div>
                                    </div>
                                </div>

                                <div className="col-lg-6 col-md-6 col-sm-12">
                                    <label className="form-label">
                                        Address
                                        <span className="fs-8 text-danger">
                                            {" "}
                                            *
                                        </span>
                                    </label>
                                    <textarea
                                        className="form-control"
                                        placeholder="Enter your address"
                                        id="text-forms-address"
                                        {...register("address", {
                                            required: true,
                                        })}
                                    ></textarea>
                                    {errors.address && (
                                        <span className="fs-8 text-danger">
                                            Address is required
                                        </span>
                                    )}
                                </div>

                                <div className="col-lg-6 col-md-6 col-sm-12">
                                    <label className="form-label">
                                        GST Number
                                        <span className="fs-8 text-danger">
                                            {" "}
                                            *
                                        </span>
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Enter gst number"
                                        id="text-forms-gst_no"
                                        {...register("gst_no", {
                                            required: true,
                                        })}
                                    />
                                </div>

                                <div className="col-lg-6 col-md-6 col-sm-12">
                                    <div className="d-flex justify-content-between">
                                        <label className="form-label">
                                            GST Certificate
                                        </label>
                                        {location.state.editpost
                                            .gst_certificate ? (
                                            <a
                                                target="_black"
                                                href={
                                                    location.state.editpost
                                                        .gst_certificate
                                                }
                                                className="btn btn-xs btn-primary"
                                            >
                                                <em className="icon ni ni-eye"></em>
                                            </a>
                                        ) : (
                                            ""
                                        )}
                                    </div>
                                    <Controller
                                        name="gst_cert"
                                        control={control}
                                        rules={{
                                            required: false,
                                            // validate: (value) => {
                                            //   const fileType = value?.[1]?.type;
                                            //   return (
                                            //     fileType === "application/pdf"
                                            //   );
                                            // },
                                        }}
                                        defaultValue=""
                                        render={({ field }) => (
                                            <input
                                                className="form-control"
                                                id="file-forms-gst_cert"
                                                type="file"
                                                onChange={(e) => {
                                                    field.onChange(
                                                        e.target.files[0]
                                                    );
                                                }}
                                            />
                                        )}
                                    />
                                </div>

                                {/* <div className="col-lg-6 col-md-6 col-sm-12">
                                    <div className="d-flex justify-content-between">
                                        <label className="form-label">
                                            Additional Documents
                                        </label>
                                        {location.state?.editpost
                                            ?.additional_docs ? (
                                            <a
                                                target="_black"
                                                href={
                                                    location.state.editpost
                                                        .additional_docs
                                                }
                                                className="btn btn-xs btn-primary"
                                            >
                                                <em className="icon ni ni-eye"></em>
                                            </a>
                                        ) : (
                                            ""
                                        )}
                                    </div>
                                    <Controller
                                        name="additional_docs"
                                        control={control}
                                        rules={{
                                            required: false,
                                            // validate: (value) => {
                                            //   const fileType = value?.[1]?.type;
                                            //   return (
                                            //     fileType === "application/pdf"
                                            //   );
                                            // },
                                        }}
                                        defaultValue=""
                                        render={({ field }) => (
                                            <input
                                                className="form-control"
                                                id="file-forms-additional_docs"
                                                type="file"
                                                onChange={(e) => {
                                                    field.onChange(
                                                        e.target.files[0]
                                                    );
                                                }}
                                            />
                                        )}
                                    />
                                </div> */}

                                <div className="col-12">
                                    <div className="form-group">
                                        <button
                                            type="button"
                                            className="btn btn-md btn-light me-2"
                                            id="submit-button-backbutton"
                                            onClick={() => navigate(-1)}
                                        >
                                            Back
                                        </button>
                                        {isPending ? (
                                            <button
                                                type="button"
                                                id="button-supplier-loading"
                                                className="btn btn-md text-dark"
                                                disabled
                                            >
                                                Loading...
                                            </button>
                                        ) : (
                                            <button
                                                type="submit"
                                                className="btn btn-md btn-primary"
                                                id="submit-button-update-supplier"
                                            >
                                                Update
                                            </button>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </>
    );
};

export default EditSupplier;
